import styled from 'styled-components';
import { Breadcrumb as AntBreadcrumb } from 'antd';
export const { Item } = AntBreadcrumb;

export const BreadcrumbItem = styled(Item)``;
export const Breadcrumb = styled(AntBreadcrumb)``;
